import { useRef } from "react";

// Components
import ContentContainer from "../../../layouts/ContentContainer/ContentContainer";
import NavBar from "../../../components/NavBar/NavBar";
import Banner from "../../../layouts/Banner/Banner";
import EmbedVideo from "../../../components/VideoContainer/EmbedVideo";
// Buttons
import ScrollToTopButton from "../../../components/Buttons/ScrollToTopButton";
// Assets

const Life = () => {
   const pageRef = useRef(null);
   return (
      <div
         ref={pageRef}
         className="page page-book base-page-culture page--font-dark"
      >
         <div className="page__inner">
            <header id="page-three-top" className="header">
               <div className="background-image--life"></div>
               <NavBar />
               <div className="hero">
                  <div className="hero__container">
                     <EmbedVideo videoCode="jq2o9601rx" embedType="wistia" />
                     <div className="hero__text">
                        <p className="hero__paragraph">
                           A couple of colleagues shared personal information
                           about their health and wellbeing and everyone was
                           really supportive and asked how they could assist to
                           make things easier.
                        </p>
                     </div>
                  </div>
               </div>
            </header>

            <main>
               <ContentContainer>
                  <div className="text-container--2col">
                     <h1 className="heading heading--primary">
                        Your working life
                     </h1>
                     <h3 className="heading heading--tertiary">
                        Working hours
                     </h3>
                     <p>
                        We are responsibly flexible – meaning we each base our
                        ‘office hours’ around the requirements of our roles,
                        clients/learners, stakeholders, leaders, and our wider
                        team. We just ask that you make sure you and your line
                        manager are clear on when you’re working and what you’re
                        working on, and whether you need any help or support.
                        Lunch has no set time either – so communication between
                        you and your team and stakeholders is important to
                        ensure everyone understands your schedule and we
                        consistently deliver.
                     </p>
                     <h3 className="heading heading--tertiary">Dress code</h3>
                     <p>
                        We don’t have a dress code policy beyond “use good
                        judgement based on your day.”
                     </p>
                     <h3 className="heading heading--tertiary">Benefits</h3>
                     <p>
                        At Avado we offer a range of diverse benefits, details
                        of which can be found on our People Hub here.
                     </p>
                  </div>
               </ContentContainer>

               <div className="banner">
                  <Banner
                     modifier="banner-life"
                     styleClass="content-container__container--2col"
                  >
                     <div></div>
                     <div className="text-container--1col text-container--white-bg text-container--small-text-container ">
                        <h3 className="heading heading--tertiary">
                           Remote working
                        </h3>
                        <p className="">
                           Connection is critical for us. Critical. It improves
                           communication and learning for everyone. We also
                           believe in flexibility, and the benefits that this
                           creates for individuals and Avado. You can find
                           further information on our Guide & Commitment to our
                           Hybrid Working Environment here. Key points to note
                           on this are:
                           <ul className="paragraph paragraph__list">
                              <li>
                                 There’s a time and a place for everything;
                                 that’s for you to decide, in collaboration with
                                 your colleagues, clients, learners, line
                                 manager, team and other Avado stakeholders.
                              </li>{" "}
                              <li>
                                 All new joiners are afforded a set up
                                 allowance.
                              </li>
                              <li>
                                 And all Avado people are afforded a monthly
                                 hybrid working allowance.
                              </li>
                           </ul>
                        </p>
                     </div>
                  </Banner>
               </div>

               <ContentContainer>
                  <div className="text-container--2col">
                     <h3 className="heading heading--tertiary">
                        Your time out from work
                     </h3>
                     <p>
                        We have a generous holiday allowance. When requesting
                        leave we ask that you request the necessary approval
                        from your leader prior to booking your holiday. Our
                        holiday year runs from 1 January to the 31 December, and
                        you begin to accrue holiday entitlement from the start
                        of your employment.
                     </p>
                     <p>Simple methodology for arranging time out</p>
                     <ul className="paragraph paragraph__list paragraph__list--highlight">
                        <li>
                           Check the dates / times with your manager, team and
                           key stakeholders
                        </li>
                        <li>Book it in Outlook and PeopleHR</li>
                        <li>
                           Book it with the travel agent / relevant external
                           holiday helper if applicable
                        </li>
                        <li>
                           Handover properly so that your team and line manager
                           know what to do while you’re out
                        </li>
                        <li>Go, relax, recharge, return</li>
                     </ul>
                     <h3 className="heading heading--tertiary">Sick days</h3>
                     <p>
                        We pay for a reasonable number of sick days, whether for
                        physical ill-health or mental ill-health. You can find
                        more information about this in our{" "}
                        <strong>guide and commitment to time away </strong>
                        on the PX Hub. If you are calling in sick, all we ask is
                        that you:
                     </p>
                     <ul className="paragraph paragraph__list paragraph__list--highlight">
                        <li>
                           Contact your line manager as close to 9am as possible
                           telling the reason why and how long you expect to be
                           away, if you even know
                        </li>
                        <li>
                           Keep in regular contact with your line manager
                           throughout your absence
                        </li>
                        <li>
                           Talk openly to us about what we can do to help you
                           settle back in following any period of absence
                        </li>
                     </ul>
                  </div>
               </ContentContainer>
               <Banner modifier="banner-life-secondary">
                  <div className="text-container text-container--white-bg">
                     <h3 className="heading heading--tertiary">
                        Mental health and wellbeing
                     </h3>
                     <div className="content-container__container--2col">
                        <p>
                           At Avado, your mental health and wellbeing is our
                           utmost importance. We therefore have partnered up
                           with Health Assured who offer a free and confidential
                           advice service 24/7 to support you on an emotional
                           level through difficult times. Details of this
                           service can be found on the PX Hub.
                        </p>
                        <p>
                           As well our Employee Assistance Programme service,
                           you can also reach out to any one of our Mental
                           Health First Aid Champions. Our Champions have all
                           been through the MHFA England accredited programme
                           and are passionate about supporting and talking about
                           Mental Health.
                        </p>
                     </div>
                  </div>
               </Banner>
               {/* <div className="banner">
            <div className="banner-container">
              <Banner modifier="banner-life-secondary"></Banner>
            </div>
          </div> */}
               <ContentContainer>
                  <ScrollToTopButton parentContainer={pageRef} />
               </ContentContainer>
            </main>
         </div>
      </div>
   );
};

export default Life;
